var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_10254)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2587 22.5H6C4.60875 22.5 3.27379 21.9469 2.28754 20.9621C1.30129 19.9777 0.75 18.6424 0.75 17.25V5.25C0.75 3.85763 1.30129 2.52225 2.28754 1.53787C3.27379 0.553124 4.60875 0 6 0H13.5C16.3988 0 18.75 2.3505 18.75 5.25V10.8848C21.3713 11.8121 23.25 14.3134 23.25 17.25C23.25 20.9753 20.2238 24 16.5 24C14.895 24 13.4175 23.4379 12.2587 22.5ZM16.5 12C19.3988 12 21.75 14.3524 21.75 17.25C21.75 20.1476 19.3988 22.5 16.5 22.5C13.6012 22.5 11.25 20.1476 11.25 17.25C11.25 14.3524 13.6012 12 16.5 12ZM19.125 16.5H17.25V13.5C17.25 13.086 16.9125 12.75 16.5 12.75C16.0875 12.75 15.75 13.086 15.75 13.5V17.25C15.75 17.6644 16.0837 18 16.5 18H19.125C19.5375 18 19.875 17.664 19.875 17.25C19.875 16.836 19.5375 16.5 19.125 16.5ZM5.625 15H9.62622C10.0387 15 10.3762 14.664 10.3762 14.25C10.3762 13.836 10.0387 13.5 9.62622 13.5H5.625C5.2125 13.5 4.875 13.836 4.875 14.25C4.875 14.664 5.2125 15 5.625 15ZM5.625 12H12C12.4163 12 12.75 11.664 12.75 11.25C12.75 10.836 12.4163 10.5 12 10.5H5.625C5.2125 10.5 4.875 10.836 4.875 11.25C4.875 11.664 5.2125 12 5.625 12ZM5.625 9H13.875C14.2875 9 14.625 8.664 14.625 8.25C14.625 7.836 14.2875 7.5 13.875 7.5H5.625C5.2125 7.5 4.875 7.836 4.875 8.25C4.875 8.664 5.2125 9 5.625 9Z",
    fill: "#C32A7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_10254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16);
export default __webpack_public_path__ + "static/media/icon16.dd11319250e54fce8c8858d180bd70b9.svg";
export { ForwardRef as ReactComponent };